import { Button } from '@hivebrite/design-system/Button';

import { INITIAL_IMAGES } from 'hb-builder/components/BuilderComponents/block/Gallery/utils/constants';
import {
  useBuilderContext,
  useComponentsContext,
  useBuilderConfigContext,
} from 'hb-builder/hooks';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import { createNewItem } from 'hb-builder/utils/createNewItem';

const AddImageButton = ({ item }: Pick<ComponentSettingsTab, 'item'>) => {
  const { addItem, getPath } = useBuilderContext();
  const { components } = useComponentsContext();
  const {
    features,
    hivebrite: { subdomainNetworkUrl },
  } = useBuilderConfigContext();

  const { GridItem } = components;
  const [sliderItem] = item.children || [];
  const isBigSlider = item.name === 'GalleryTemplateBigSlider';

  const childrenLength = sliderItem?.children?.length || 0;
  const initialImages = INITIAL_IMAGES({
    features,
  });
  const image = initialImages[Math.floor(Math.random() * initialImages.length)];

  const addImage = () => {
    const newImage = createNewItem(
      GridItem.item({
        image,
        index: childrenLength,
        subdomainNetworkUrl,
      }),
    );

    addItem({
      direction: childrenLength + 1,
      id: sliderItem.id,
      item: newImage,
      path: getPath(sliderItem.id),
    });
  };

  if (childrenLength > 11 || (isBigSlider && childrenLength > 5)) {
    return null;
  }

  return (
    <Button
      fontFamily="Inter"
      m="10px 20px"
      onClick={addImage}
      variant="primary"
    >
      {__('Add an image')}
    </Button>
  );
};

export default AddImageButton;
